import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Inbox from "@material-ui/icons/Inbox";
import { useGetResourceLabel, useListContext, useResourceContext, useTranslate } from "ra-core";
import * as React from "react";
import { CreateButton } from "react-admin";

export const EmptyEx = ({
	defaultEmptyMessage,
	defaultInviteMessage,
	customActions = null,
	hideDefaultCreate = false,
	resource: resourceProp,
	...props
}) => {
	const { basePath, hasCreate } = useListContext(props);
	const resourceFromContext = useResourceContext(props);
	const resource = resourceProp || resourceFromContext;
	const classes = useStyles(props);
	const translate = useTranslate();

	const getResourceLabel = useGetResourceLabel();
	const resourceName = translate(`resources.${resource}.forcedCaseName`, {
		smart_count: 0,
		_: getResourceLabel(resource, 0),
	});

	const emptyMessage = defaultEmptyMessage || translate("ra.page.empty", { name: resourceName });
	const inviteMessage = defaultInviteMessage || translate("ra.page.invite");

	return (
		<>
			<div className={classes.message}>
				<Inbox className={classes.icon} />
				<Typography variant="h4" paragraph>
					{translate(`resources.${resource}.empty`, {
						_: emptyMessage,
					})}
				</Typography>
				{(hasCreate || customActions) && (
					<Typography variant="body1">
						{translate(`resources.${resource}.invite`, {
							_: inviteMessage,
						})}
					</Typography>
				)}
			</div>
			{customActions ? (
				<div className={classes.toolbar}>{customActions}</div>
			) : (
				hasCreate &&
				!hideDefaultCreate && (
					<div className={classes.toolbar}>
						<CreateButton variant="contained" basePath={basePath} />
					</div>
				)
			)}
		</>
	);
};

const useStyles = makeStyles(
	(theme) => ({
		message: {
			textAlign: "center",
			opacity: theme.palette.type === "light" ? 0.5 : 0.8,
			margin: "0 1em",
			color: theme.palette.type === "light" ? "inherit" : theme.palette.text.primary,
		},
		icon: {
			width: "9em",
			height: "9em",
		},
		toolbar: {
			textAlign: "center",
			marginTop: "2em",
			display: "flex",
			gap: "1em",
			justifyContent: "center",
			flexWrap: "wrap",
		},
	}),
	{ name: "RaEmpty" }
);
